export const GET_HOT_SEARCH_START = 'GET_HOT_SEARCH_START';
export const GET_HOT_SEARCH_SUCCESS = 'GET_HOT_SEARCH_SUCCESS';
export const GET_HOT_SEARCH_FAILURE = 'GET_HOT_SEARCH_FAILURE';

export const GET_HOT_SEARCH_APP_START = 'GET_HOT_SEARCH_APP_START';
export const GET_HOT_SEARCH_APP_SUCCESS = 'GET_HOT_SEARCH_APP_SUCCESS';
export const GET_HOT_SEARCH_APP_FAILURE = 'GET_HOT_SEARCH_APP_FAILURE';

export const GET_LENOVOWORDS_SEARCH_START = 'GET_LENOVOWORDS_SEARCH_START';
export const GET_LENOVOWORDS_SEARCH_SUCCESS = 'GET_LENOVOWORDS_SEARCH_SUCCESS';
export const GET_LENOVOWORDS_SEARCH_FAILURE = 'GET_LENOVOWORDS_SEARCH_FAILURE';

export const GET_RESULT_SEARCH_START = 'GET_RESULT_SEARCH_START';
export const GET_RESULT_SEARCH_SUCCESS = 'GET_RESULT_SEARCH_SUCCESS';
export const GET_RESULT_SEARCH_FAILURE = 'GET_RESULT_SEARCH_FAILURE';

export const GET_SEARCH_RECOMMEND_START = 'GET_SEARCH_RECOMMEND_START';
export const GET_SEARCH_RECOMMEND_SUCCESS = 'GET_SEARCH_RECOMMEND_SUCCESS';
export const GET_SEARCH_RECOMMEND_FAILURE = 'GET_SEARCH_RECOMMEND_FAILURE';

export const CLEAN_SEARCH_RECOMMEND_START = 'CLEAN_SEARCH_RECOMMEND_START';
export const CLEAN_SEARCH_RECOMMEND_SUCCESS = 'CLEAN_SEARCH_RECOMMEND_SUCCESS';
export const GET_FEEDBACK_SUGGEST = 'GET_FEEDBACK_SUGGEST';
export const SET_FEEDBACK_SUGGEST = 'SET_FEEDBACK_SUGGEST';
